// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3cKEh","name":"ConsentHeader_name__DuCyZ","birthday":"ConsentHeader_birthday__1-VZX","skeleton":"ConsentHeader_skeleton__q-_N5"};